import { useState, useEffect } from "react";
import useSWR from "swr";
import ReportService from "services/ReportService";
import useDealer from "./useDealer";
import useDealersSwr from "./useDealersSwr";

const useOrderMarginReport = (startDate = "", endDate = "", selectedCountry) => {
    const { id: dealerId } = useDealer();
    const { dealers = [] } = useDealersSwr();

    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sortBy, setSortBy] = useState([]);

    useEffect(() => {
        setPageIndex(1);
    }, [startDate, endDate, dealerId, selectedCountry]);

    const dealerIdsToUse =
        dealerId === 0
            ? dealers
                .filter((d) => !selectedCountry || d.country === selectedCountry)
                .map((d) => d.id)
            : [dealerId];

    const shouldFetch = dealerIdsToUse && dealerIdsToUse.length > 0;

    const { data, error } = useSWR(
        shouldFetch
            ? [
                "order-margin-summary",
                dealerIdsToUse,
                startDate,
                endDate,
                selectedCountry,
                pageIndex,
                pageSize,
                sortBy,
            ]
            : null,
        () =>
            ReportService.fetchOrderMarginSummary(
                dealerIdsToUse,
                startDate,
                endDate,
                pageIndex,
                pageSize,
                sortBy
            ).then((res) => res.data),
        {
            keepPreviousData: true,
            revalidateOnFocus: false,
        }
    );

    const changePagination = ({
        pageIndex: newPageIndex,
        pageSize: newPageSize,
        sortBy: newSortBy,
    }) => {
        setPageIndex(newPageIndex);
        setPageSize(newPageSize);
        setSortBy(newSortBy || []);
    };

    return {
        data: data?.data || [],
        total: data?.total || 0,
        pageIndex: pageIndex,
        pageSize: pageSize || 10,
        setPageIndex,
        changePagination,
    };
};

export default useOrderMarginReport;
